import { Injectable } from '@angular/core';
import { ConfigRequestsInterface, InitializableInterface } from '@evorait/pace-core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigInterfaceService implements ConfigRequestsInterface, InitializableInterface {
    public isInitialized = false;
    public offlineStoreDefiningRequests: string[];

    /**
     * Initializes configuration parameters that depend on the app id. Since the class is only used statically, there is
     * no new instance created ever and we need to call a static initializer function to fill our definingRequests array.
     *
     * @returns {Observable<string[]>} An observable that emits the defining requests
     */
    public init(): Observable<string[]> {
        this.offlineStoreDefiningRequests = [];

        this.isInitialized = true;

        return of(this.offlineStoreDefiningRequests);
    }
}
